module.exports = __webpack_public_path__ + "img/move.c31fff29.svg";